import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { APIErrorResponse, AttentionTask } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { QUERY_KEYS } from '@/constants'

export type UseDeleteAttentionTaskProps = {
  target_type: AttentionTask['target_type']
  target_id: number
}

export const useDeleteAttentionTask = ({
  target_type,
  target_id,
}: UseDeleteAttentionTaskProps): UseMutationResult<
  void,
  APIErrorResponse,
  number
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    (taskId: number) =>
      client
        .delete(`plannings/attention_tasks/${taskId}/`)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([
          QUERY_KEYS.ATTENTION_TASKS,
          target_type,
          target_id,
        ])
      },
    }
  )
}
